import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {BaseComponent} from '@ui-app/components/base.component';
import {USER_DATA_SERVICE, UserDataServiceUI} from '@ui-app/app.module';
import {AdobeLaunchService} from '@ui-app/services/adobe-launch.service';
import * as UIModels from '@shared-models/index';
import {UserRuleReader} from '@ui-app/services/user-rules-reader.service';


@Injectable({
    providedIn: 'root'
})

/**
 * User service
 */
export class UserProfileService extends BaseComponent {
    private userData: UIModels.CM.IUserData;
    private userDataSource = new BehaviorSubject<UIModels.CM.IUserData>(null);

    constructor(
        @Inject(USER_DATA_SERVICE) private userDataService: UserDataServiceUI,
        private userRuleReader: UserRuleReader,
        private adobeLaunchService: AdobeLaunchService) {
        super();
    }

    get userData$(): Observable<UIModels.CM.IUserData> {
        return this.userDataSource.asObservable();
    }

    get user(): UIModels.CM.IUserData {
        // TODO: Avoid of Object.assign if Models.DM.IUserData have nested data
        return this.userData && {...this.userData};
    }

    set user(userData: UIModels.CM.IUserData) {
        this.userData = userData;
        this.adobeLaunchService.setUser(userData.alias);
    }


    getUserData(): Observable<UIModels.CM.IUserData> {
        return this.userDataService.getUserData().pipe(
            map((response: UIModels.CM.IUserData) => {
                this.user = this.userRuleReader.modifyUserRole(response);
                sessionStorage.setItem('userCountry', response.country);
                this.adobeLaunchService.setUser(response.alias);
                this.userDataSource.next(response);
                return this.user;
            }),
            catchError((error) => {
                this.user = null;

                return throwError(error);
            })
        ) as Observable<UIModels.CM.IUserData>;
    }

    isUserSessionReady(requiredRolesIds: Array<UIModels.CE.UserRoleEnum> = null): boolean {
        if (!this.userData) { return false; }
        if (this.userData.userRoleIds?.length) {
            return this.userData.userRoleIds.some(id => requiredRolesIds.includes(id));
        }
        return requiredRolesIds.includes(this.userData.userRoleId);
    }
}
